var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 13.052V15.5854C1 15.8187 1.18333 16.002 1.41667 16.002H3.95C4.05833 16.002 4.16667 15.9604 4.24167 15.877L13.3417 6.78537L10.2167 3.66037L1.125 12.752C1.04167 12.8354 1 12.9354 1 13.052ZM15.7583 3.1937L13.8083 1.2437C13.7312 1.16645 13.6397 1.10516 13.5389 1.06334C13.438 1.02152 13.33 1 13.2208 1C13.1117 1 13.0036 1.02152 12.9028 1.06334C12.802 1.10516 12.7104 1.16645 12.6333 1.2437L11.1083 2.7687L14.2333 5.8937L15.7583 4.3687C15.8356 4.29161 15.8969 4.20003 15.9387 4.09922C15.9805 3.99841 16.002 3.89034 16.002 3.7812C16.002 3.67206 15.9805 3.56399 15.9387 3.46318C15.8969 3.36237 15.8356 3.2708 15.7583 3.1937Z",
    fill: "#215CA7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGroupIcon);
export default __webpack_public_path__ + "static/media/EditGroupIcon.97165272071c0c00d048f9a1151f3ace.svg";
export { ForwardRef as ReactComponent };